/**
 * @generated SignedSource<<d255385cb9aad5d9d20a9edc606b300c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutinePositivePercentageRoutineItem_routine$data = {
  readonly id: string;
  readonly lastCompletedOccasion: {
    readonly endAt: string;
    readonly percentage: number | null;
  } | null;
  readonly ownerTeam: {
    readonly name: string;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "WidgetRoutinePositivePercentageRoutineItem_routine";
};
export type WidgetRoutinePositivePercentageRoutineItem_routine$key = {
  readonly " $data"?: WidgetRoutinePositivePercentageRoutineItem_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentageRoutineItem_routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutinePositivePercentageRoutineItem_routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "ownerTeam",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasion",
      "kind": "LinkedField",
      "name": "lastCompletedOccasion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "59e6449caf43f743d23c83b5aef6940f";

export default node;
